import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import {
  ChatDisabled,
  NoConversation,
} from '@/features/jobs/details/components/CommunicationView'
import { ListContainer } from '@/features/messaging/components/ConversationView/Messages/List/ListContainer'
import { TypingIndicator } from '@/features/messaging/components/ConversationView/TypingIndicator'
import {
  MobileChatTab,
  MobileConversation,
} from '@/features/jobs/details/components/MobileJob'
import { MobileConversationComposerContainer } from './MobileConversationComposerContainer'

export interface MobileJobChatContainerProps {
  vm: JobDetailsViewModel
}

export const MobileJobChatContainer = observer(function MobileJobChatContainer({
  vm,
}: MobileJobChatContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  if (!vm.canViewChat) {
    return (
      <MobileChatTab>
        <ChatDisabled corporateMode={shellInfo.corporateMode} />
      </MobileChatTab>
    )
  }

  if (vm.job.conversation === null) {
    return (
      <MobileChatTab>
        <NoConversation corporateMode={shellInfo.corporateMode} />
      </MobileChatTab>
    )
  }

  return (
    <MobileConversation
      readOnly={vm.isChatReadOnly}
      messages={<ListContainer vm={vm.conversationVm} />}
      composer={
        <MobileConversationComposerContainer
          conversationVm={vm.conversationVm}
        />
      }
      typingIndicator={<TypingIndicator />}
    />
  )
})
